export default "__VITE_ASSET__BijYFZ9___"